import { NavLink } from 'react-router-dom';

const navItems = [
  { path: '/', icon: '🏠', label: 'Главная' },
  { path: '/listings', icon: '🛍', label: 'Товары' },
  { path: '/auctions', icon: '🕑', label: 'Аукционы' },
  { path: '/chats', icon: '💬', label: 'Чаты' },
  { path: '/profile', icon: '👤', label: 'Профиль' }
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-tg-theme-bg border-t border-tg-theme-secondary-bg safe-area-bottom">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center px-3 py-2 ${
                isActive ? 'text-tg-theme-button' : 'text-tg-theme-hint'
              }`
            }
          >
            <span className="text-xl">{item.icon}</span>
            <span className="text-xs mt-1">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
